import {  TileLayer } from "deck.gl";
import { hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions";
import { PMTiles } from 'pmtiles'
import { MVTLoader } from "@loaders.gl/mvt";
import { parse } from "@loaders.gl/core";

export function BuildingAreaLayer(workspace, layerName, is3D, opacity, zoom, dataSource) {
        const pmtiles = new PMTiles(dataSource)

        return (
                new TileLayer({
                        id: 'BuildingAreaLayer1',
                        data: null,
                        getTileData: async (tile) => {
                                const { x, y, z } = tile.index;
                                const res = await pmtiles.getZxy(z, x, y);
                                const data = res.data ? new Uint8Array(res.data) : new Uint8Array();
                                return parse(data, MVTLoader, {
                                        loadOptions: { worker: true },
                                        mvt: {
                                                coordinates: "wgs84",
                                                tileIndex: { x, y, z },
                                        },
                                });
                        },
                        tileSize: 256,
                        onTileLoad: showLoading,
                        onViewportLoad: hideLoading,
                        opacity: opacity / 100,
                        stroked: true,
                        filled: true,
                        maxZoom: 15,
                        // extruded: is3D,
                        // wireframe: false,
                        getLineColor: f => {
                                const a = f.properties.area
                                if (a <= 100) {
                                        return [68, 1, 84]
                                }
                                else if (a <= 250) {
                                        return [58, 82, 139]
                                }
                                else if (a <= 500) {
                                        return [32, 144, 140]
                                }
                                else if (a <= 1000) {
                                        return [94, 201, 98]
                                }
                                return [255, 255, 0]
                        },
                        // getLineColor: f => {
                        //     console.log(f)
                        //     return [0, 0, 0, 150]
                        // },
                        getFillColor: f => {
                                const a = f.properties.area
                                if (a <= 100) {
                                        return [68, 1, 84]
                                }
                                else if (a <= 250) {
                                        return [58, 82, 139]
                                }
                                else if (a <= 500) {
                                        return [32, 144, 140]
                                }
                                else if (a <= 1000) {
                                        return [94, 201, 98]
                                }
                                return [255, 255, 0]
                        },
                        getLineWidth: 1.0,
                        lineWidthMinPixels: 1.0,
                        pickable: true,
                        getElevation: is3D ? d => d.properties.height : 0,
                        terrainDrawMode: is3D ? 'offset' : '',
                        extruded: is3D,
                        extensions: is3D
                                ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                                : [new DataFilterExtension({ filterSize: 1 })],

                        visible: true,
                        dataComparator: (a, b) => false
                })
        )
}

        